module.exports = __webpack_public_path__ + "static/bams-cda41a6721b24d99cb13e1f89e5abb90.svg";